import React from 'react';
import FoundersSection from '../../components/FoundersSection';
import WhyChooseUsSection from '../../components/WhyChooseUsSection';
import CTASection from '../../components/CTASection';
import SEO from '../components/SEO';
import ErrorBoundary from '../components/ErrorBoundary';
const MeetUsPage = () => {
  // Structured data for people
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Curtis & Spring Eatmon',
    description: 'Faith-driven entrepreneurs, coaches, and the power couple behind Max Life Agency, Legacy Lab, and a growing faith-based media company.',
    url: 'https://legacylabfinancial.com/meet-us',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uDq2sVieMxguTNrnjMyEbR/Screenshot_2025-06-18_at_9.49.51_PM.png',
    jobTitle: 'Founders',
    worksFor: {
      '@type': 'Organization',
      name: 'Legacy Lab Financial'
    }
  };
  return <>
      <SEO title="Meet Us" description="Get to know the founders and leaders behind Legacy Lab Financial who are committed to helping you build wealth and create a lasting legacy." structuredData={structuredData} data-id="element-417" />
      <div className="py-16 px-4 text-center" data-id="element-418">
        <h1 className="text-4xl sm:text-5xl font-bold" data-id="element-419">
          Meet <span className="text-gradient" data-id="element-420">the Team</span>
        </h1>
        <p className="mt-6 max-w-3xl mx-auto text-lg text-gray-600" data-id="element-421">
          Get to know the founders and leaders behind Legacy Lab Financial who
          are committed to helping you build wealth and create a lasting legacy.
        </p>
      </div>
      <ErrorBoundary data-id="element-422">
        <FoundersSection data-id="element-423" />
      </ErrorBoundary>
      <ErrorBoundary data-id="element-424">
        <WhyChooseUsSection data-id="element-425" />
      </ErrorBoundary>
      <ErrorBoundary data-id="element-426">
        <CTASection data-id="element-427" />
      </ErrorBoundary>
    </>;
};
export default MeetUsPage;